export const printTemFnMap = {
    'printFn_dtp': (handleFn) => {
        setTimeout(() => {
            handleFn && handleFn()
        }, 100);
    },

    'jxl': (params) => {
        let printWidth = 110;
        let printHeight = 275;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;

        //线条通用配置
        let lineConfig = {
            type: 'line',// 类型
            lineWidth: 1,// 线宽
            x1: 0,// x轴起点
            x2: printWidth,// x轴终点
        };

        //标题通用配置
        let titleConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 27.5, // 区域宽度
            height: 15,// 区域高度
        };

        //内容通用配置
        let textConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 82.5,// 区域宽度
            height: 15,// 区域高度
            x: 27.5,// x轴起点
        };
        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 30 + marginTopHeight },
            { ...lineConfig, y1: 45 + marginTopHeight, y2: 45 + marginTopHeight },
            { ...lineConfig, y1: 60 + marginTopHeight, y2: 60 + marginTopHeight },
            { ...lineConfig, y1: 90 + marginTopHeight, y2: 90 + marginTopHeight },
            { ...lineConfig, y1: 105 + marginTopHeight, y2: 105 + marginTopHeight },
            { ...lineConfig, y1: 135 + marginTopHeight, y2: 135 + marginTopHeight },
            { ...lineConfig, y1: 150 + marginTopHeight, y2: 150 + marginTopHeight },
            { ...lineConfig, y1: 165 + marginTopHeight, y2: 165 + marginTopHeight },
            { ...lineConfig, y1: 180 + marginTopHeight, y2: 180 + marginTopHeight },
            { ...lineConfig, y1: 195 + marginTopHeight, y2: 195 + marginTopHeight },
            { ...lineConfig, y1: 210 + marginTopHeight, y2: 210 + marginTopHeight },
            { ...lineConfig, y1: 225 + marginTopHeight, y2: 225 + marginTopHeight },
            { ...lineConfig, y1: 240 + marginTopHeight, y2: 240 + marginTopHeight },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 50, x1: 27.5, x2: 27.5, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 55, x2: 55, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 82.5, x2: 82.5, },
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 45 + marginTopHeight, x1: 62.5, x2: 62.5 },
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 45 + marginTopHeight, x1: 90, x2: 90 },
            { ...lineConfig, y1: 136 + marginTopHeight, y2: 151 + marginTopHeight, x1: 28.5, x2: 0 },
            //标题
            { ...titleConfig, y: 20, text: '安方苏州分公司吉祥路仓库物资卡片', height: 30, width: 100, x: 5, fontHeight: 9, },
            { ...titleConfig, y: 50, text: '物料编码' },
            { ...titleConfig, y: 50, text: '计量单位', x: 62.5 },
            { ...titleConfig, y: 65, text: '批次号', },
            { ...titleConfig, y: 80, text: '物料描述', height: 30 },
            { ...titleConfig, y: 110, text: '供应商', },
            { ...titleConfig, y: 125, text: '备注', height: 30, },
            { ...titleConfig, y: 157, text: '日期', height: 15, verticalAlignment: 0, horizontalAlignment: 0, fontHeight: 6 },
            { ...titleConfig, y: 155, text: params.date?.split('-')[0] || new Date().getFullYear() + '', height: 15, verticalAlignment: 2, horizontalAlignment: 2 },
            { ...titleConfig, y: 155, x: 27.5, text: '入库数量', height: 15, },
            { ...titleConfig, y: 155, x: 55, text: '出库数量', height: 15, },
            { ...titleConfig, y: 155, x: 82.5, text: '库存数量', height: 15, },
            //内容
            { ...textConfig, y: 50, x: 27.5, width: 35, text: params.wlbm || '', },
            { ...textConfig, y: 65, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 80, text: params.wlms || '', height: 30, },
            { ...textConfig, y: 50, x: 90, width: 20, text: params.dddw || '', },
            // { ...textConfig, y: 110, text: params.num + '' || '', fontHeight: 8.5 },
            { ...textConfig, y: 110, text: params.gysmc || '' },
            { ...textConfig, y: 125, text: params.remarks || '', height: 30, },
            { ...textConfig, y: 170, x: 0, width: 27.5, text: params.date?.split('-').filter((item, index) => index !== 0).join('/') || (new Date().getMonth() + 1).toString().padStart(2, "0") + "-" + new Date().getDate().toString().padStart(2, "0"), height: 15, fontHeight: 8.5 },
            { ...textConfig, y: 170, x: 27.5, width: 27.5, text: (params.numberDisks ?? '') + '' || '', height: 15, },
            { ...textConfig, y: 170, x: 55, width: 27.5, text: (params.quantityIssued ?? '') + '', height: 15, },
            { ...textConfig, y: 170, x: 82.5, width: 27.5, text: ((params.balanceQuantity ?? '') + ''), height: 15, },
        ]);
    },

    'dl': (params) => {
        let printWidth = 110;
        let printHeight = 275;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;

        //线条通用配置
        let lineConfig = {
            type: 'line',// 类型
            lineWidth: 1,// 线宽
            x1: 0,// x轴起点
            x2: printWidth,// x轴终点
        };

        //标题通用配置
        let titleConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 27.5, // 区域宽度
            height: 15,// 区域高度
        };

        //内容通用配置
        let textConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 82.5,// 区域宽度
            height: 15,// 区域高度
            x: 27.5,// x轴起点
        };
        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 30 + marginTopHeight },
            { ...lineConfig, y1: 45 + marginTopHeight, y2: 45 + marginTopHeight },
            { ...lineConfig, y1: 60 + marginTopHeight, y2: 60 + marginTopHeight },
            { ...lineConfig, y1: 75 + marginTopHeight, y2: 75 + marginTopHeight },
            { ...lineConfig, y1: 90 + marginTopHeight, y2: 90 + marginTopHeight },
            { ...lineConfig, y1: 120 + marginTopHeight, y2: 120 + marginTopHeight },
            { ...lineConfig, y1: 135 + marginTopHeight, y2: 135 + marginTopHeight },
            { ...lineConfig, y1: 165 + marginTopHeight, y2: 165 + marginTopHeight },
            { ...lineConfig, y1: 180 + marginTopHeight, y2: 180 + marginTopHeight },
            { ...lineConfig, y1: 195 + marginTopHeight, y2: 195 + marginTopHeight },
            { ...lineConfig, y1: 210 + marginTopHeight, y2: 210 + marginTopHeight },
            { ...lineConfig, y1: 225 + marginTopHeight, y2: 225 + marginTopHeight },
            { ...lineConfig, y1: 240 + marginTopHeight, y2: 240 + marginTopHeight },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 50, x1: 27.5, x2: 27.5, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 185, x1: 55, x2: 55, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 185, x1: 82.5, x2: 82.5, },
            { ...lineConfig, y1: 60 + marginTopHeight, y2: 75 + marginTopHeight, x1: 62.5, x2: 62.5 },
            { ...lineConfig, y1: 60 + marginTopHeight, y2: 75 + marginTopHeight, x1: 90, x2: 90 },
            { ...lineConfig, y1: 166 + marginTopHeight, y2: 181 + marginTopHeight, x1: 28.5, x2: 0 },
            //标题
            { ...titleConfig, y: 20, text: '安方苏州分公司胥口仓库物资卡片', height: 30, width: 100, x: 5, fontHeight: 10, },
            { ...titleConfig, y: 50, text: '仓位号', },
            { ...titleConfig, y: 65, text: '出厂编码', },
            { ...titleConfig, y: 80, text: '物料编码' },
            { ...titleConfig, y: 80, text: '计量单位', x: 62.5 },
            { ...titleConfig, y: 95, text: '批次号', },
            { ...titleConfig, y: 110, text: '物料描述', height: 30 },
            { ...titleConfig, y: 140, text: '供应商', },
            { ...titleConfig, y: 155, text: '备注', height: 30, },
            { ...titleConfig, y: 187, text: '入库日期', height: 15, verticalAlignment: 0, horizontalAlignment: 0, fontHeight: 4 },
            { ...titleConfig, y: 185, text: params.date?.split('-')[0] || new Date().getFullYear() + '', height: 15, verticalAlignment: 2, horizontalAlignment: 2 },
            { ...titleConfig, y: 185, x: 27.5, text: '组盘长度', height: 15, },
            { ...titleConfig, y: 185, x: 55, text: '发出数量', height: 15, },
            { ...titleConfig, y: 185, x: 82.5, text: '结存长度', height: 15, },
            //内容
            { ...textConfig, y: 50, x: 27.5, text: params.shippingSpace || '', },
            { ...textConfig, y: 65, x: 27.5, text: params.factoryCode || '', },
            { ...textConfig, y: 80, x: 27.5, width: 35, text: params.wlbm || '', },
            { ...textConfig, y: 95, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 110, text: params.wlms || '', height: 30, },
            { ...textConfig, y: 80, x: 90, width: 20, text: params.dddw || '', },
            { ...textConfig, y: 140, text: params.gysmc || '' },
            { ...textConfig, y: 155, text: params.remarks || '', height: 30, },
            { ...textConfig, y: 200, x: 0, width: 27.5, text: params.date?.split('-').filter((item, index) => index !== 0).join('/') || (new Date().getMonth() + 1).toString().padStart(2, "0") + "-" + new Date().getDate().toString().padStart(2, "0"), height: 15, fontHeight: 8.5 },
            { ...textConfig, y: 200, x: 27.5, width: 27.5, text: (params.numberDisks ?? '') + '' || '', height: 15, },
            { ...textConfig, y: 200, x: 55, width: 27.5, text: (params.quantityIssued ?? '') + '', height: 15, },
            { ...textConfig, y: 200, x: 82.5, width: 27.5, text: ((params.balanceQuantity ?? '') + ''), height: 15, },
        ]);
    },

    'tp': (params) => {
        let printWidth = 110;
        let printHeight = 275;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;

        //线条通用配置
        let lineConfig = {
            type: 'line',// 类型
            lineWidth: 1,// 线宽
            x1: 0,// x轴起点
            x2: printWidth,// x轴终点
        };

        //标题通用配置
        let titleConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 27.5, // 区域宽度
            height: 15,// 区域高度
        };

        //内容通用配置
        let textConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 82.5,// 区域宽度
            height: 15,// 区域高度
            x: 27.5,// x轴起点
        };
        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 30 + marginTopHeight },
            { ...lineConfig, y1: 45 + marginTopHeight, y2: 45 + marginTopHeight },
            { ...lineConfig, y1: 60 + marginTopHeight, y2: 60 + marginTopHeight },
            { ...lineConfig, y1: 75 + marginTopHeight, y2: 75 + marginTopHeight },
            { ...lineConfig, y1: 105 + marginTopHeight, y2: 105 + marginTopHeight },
            { ...lineConfig, y1: 120 + marginTopHeight, y2: 120 + marginTopHeight },
            { ...lineConfig, y1: 150 + marginTopHeight, y2: 150 + marginTopHeight },
            { ...lineConfig, y1: 165 + marginTopHeight, y2: 165 + marginTopHeight },
            { ...lineConfig, y1: 180 + marginTopHeight, y2: 180 + marginTopHeight },
            { ...lineConfig, y1: 195 + marginTopHeight, y2: 195 + marginTopHeight },
            { ...lineConfig, y1: 210 + marginTopHeight, y2: 210 + marginTopHeight },
            { ...lineConfig, y1: 225 + marginTopHeight, y2: 225 + marginTopHeight },
            { ...lineConfig, y1: 240 + marginTopHeight, y2: 240 + marginTopHeight },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 50, x1: 27.5, x2: 27.5, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 170, x1: 55, x2: 55, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 170, x1: 82.5, x2: 82.5, },
            { ...lineConfig, y1: 45 + marginTopHeight, y2: 60 + marginTopHeight, x1: 62.5, x2: 62.5 },
            { ...lineConfig, y1: 45 + marginTopHeight, y2: 60 + marginTopHeight, x1: 90, x2: 90 },
            { ...lineConfig, y1: 151 + marginTopHeight, y2: 166 + marginTopHeight, x1: 28.5, x2: 0 },
            //标题
            { ...titleConfig, y: 20, text: '安方苏州分公司胥口仓库物资卡片', height: 30, width: 100, x: 5, fontHeight: 10, },
            { ...titleConfig, y: 50, text: '托盘号', },
            { ...titleConfig, y: 65, text: '物料编码' },
            { ...titleConfig, y: 65, text: '计量单位', x: 62.5 },
            { ...titleConfig, y: 80, text: '批次号', },
            { ...titleConfig, y: 95, text: '物料描述', height: 30 },
            { ...titleConfig, y: 125, text: '供应商', },
            { ...titleConfig, y: 140, text: '备注', height: 30, },
            { ...titleConfig, y: 172, text: '日期', height: 15, verticalAlignment: 0, horizontalAlignment: 0, fontHeight: 6 },
            { ...titleConfig, y: 170, text: params.date?.split('-')[0] || new Date().getFullYear() + '', height: 15, verticalAlignment: 2, horizontalAlignment: 2 },
            { ...titleConfig, y: 170, x: 27.5, text: '组盘数量', height: 15, },
            { ...titleConfig, y: 170, x: 55, text: '发出数量', height: 15, },
            { ...titleConfig, y: 170, x: 82.5, text: '结存数量', height: 15, },
            //内容
            { ...textConfig, y: 50, x: 27.5, text: params.stock || '', },
            { ...textConfig, y: 65, x: 27.5, width: 35, text: params.wlbm || '', },
            { ...textConfig, y: 80, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 95, text: params.wlms || '', height: 30, },
            { ...textConfig, y: 65, x: 90, width: 20, text: params.dddw || '', },
            { ...textConfig, y: 125, text: params.gysmc || '' },
            { ...textConfig, y: 140, text: params.remarks || '', height: 30, },
            { ...textConfig, y: 185, x: 0, width: 27.5, text: params.date?.split('-').filter((item, index) => index !== 0).join('/') || (new Date().getMonth() + 1).toString().padStart(2, "0") + "-" + new Date().getDate().toString().padStart(2, "0"), height: 15, fontHeight: 8.5 },
            { ...textConfig, y: 185, x: 27.5, width: 27.5, text: (params.numberDisks ?? '') + '' || '', height: 15, },
            { ...textConfig, y: 185, x: 55, width: 27.5, text: (params.quantityIssued ?? '') + '', height: 15, },
            { ...textConfig, y: 185, x: 82.5, width: 27.5, text: ((params.balanceQuantity ?? '') + ''), height: 15, },
        ]);
    },

    'lyg': (params) => {
        let printWidth = 110;
        let printHeight = 185;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;
        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { type: 'line', x1: 0, y1: 30 + marginTopHeight, x2: printWidth, y2: 30 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 45 + marginTopHeight, x2: printWidth, y2: 45 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 60 + marginTopHeight, x2: printWidth, y2: 60 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 90 + marginTopHeight, x2: printWidth, y2: 90 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 105 + marginTopHeight, x2: printWidth, y2: 105 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 120 + marginTopHeight, x2: printWidth, y2: 120 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 135 + marginTopHeight, x2: printWidth, y2: 135 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 150 + marginTopHeight, x2: printWidth, y2: 150 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 30, y1: 165 + marginTopHeight, x2: 30, y2: 50, lineWidth: 1 },
            //标题
            { type: 'text', text: '安方连云港分公司珠江路仓库物资卡片', width: 110, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 20, fontStyle: 1, fontHeight: 9 },
            { type: 'text', text: '物料编码', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 50, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '批次号', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 65, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '物料描述', width: 30, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 80, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '计量单位', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 110, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '物资数量', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 125, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '库位', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 140, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '供应商', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 155, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '备注', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 170, fontStyle: 1, fontHeight: 6.5 },
            //内容
            // { type: 'text', text: '物资卡片', width: 90, height: 20, fontHeight: 4 ,verticalAlignment:1,horizontalAlignment:1,y:5,x:20},
            { type: 'text', text: params.wlbm || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 50, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.pc || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 65, x: 30, fontStyle: 1, fontHeight: 8.5 },
            { type: 'text', text: params.wlms || '', width: 80, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 80, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.dddw || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 110, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: (params.materialsNum ?? '') + '' || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 125, x: 30, fontStyle: 1, fontHeight: 8.5 },
            { type: 'text', text: params.storageLocationProject || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 140, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.gysmc || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 155, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.remarks || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 170, x: 30, fontStyle: 1, fontHeight: 6 },
            // { type: 'roundRectangle', width: printWidth, height: labelHeight, lineWidth: 0.4, cornerWidth: 2 },
            // {
            //   type: "barcode",
            //   text: "12345678",
            //   x: 5,
            //   y: 5,
            //   width: 30,
            //   height: 20,
            //   textHeight: 4,
            //   textAlignment: 3,
            // },

            // { type: 'qrcode', text: text1, x: 10, y: 5, width: 20, eccLevel: 1 },
            // { type: 'pdf417', text: text2, x: 5, y: 5, width: 30, height: 20 },
            // // 绘制图片url
            // { type: 'image', imageFile: url, x: 10, y: 5, width: 20, height: 20 },
            // // 绘制BASE64字符串
            // { type: 'image', imageFile: imgSrc, x: 10, y: 5, width: 20, height: 20 },

            // { type: 'dashLine', x1: 0, y1: 10, x2: printWidth, y2: 10, lineWidth: 0.4, dashLen: '1,0.5' },
        ]);
    },

    'lygTwo': (params) => {
        let printWidth = 110;
        let printHeight = 275;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;

        //线条通用配置
        let lineConfig = {
            type: 'line',// 类型
            lineWidth: 1,// 线宽
            x1: 0,// x轴起点
            x2: printWidth,// x轴终点
        };

        //标题通用配置
        let titleConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 27.5, // 区域宽度
            height: 15,// 区域高度
        };

        //内容通用配置
        let textConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 82.5,// 区域宽度
            height: 15,// 区域高度
            x: 27.5,// x轴起点
        };
        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 30 + marginTopHeight },
            { ...lineConfig, y1: 45 + marginTopHeight, y2: 45 + marginTopHeight },
            { ...lineConfig, y1: 60 + marginTopHeight, y2: 60 + marginTopHeight },
            { ...lineConfig, y1: 90 + marginTopHeight, y2: 90 + marginTopHeight },
            { ...lineConfig, y1: 105 + marginTopHeight, y2: 105 + marginTopHeight },
            { ...lineConfig, y1: 135 + marginTopHeight, y2: 135 + marginTopHeight },
            { ...lineConfig, y1: 150 + marginTopHeight, y2: 150 + marginTopHeight },
            { ...lineConfig, y1: 165 + marginTopHeight, y2: 165 + marginTopHeight },
            { ...lineConfig, y1: 180 + marginTopHeight, y2: 180 + marginTopHeight },
            { ...lineConfig, y1: 195 + marginTopHeight, y2: 195 + marginTopHeight },
            { ...lineConfig, y1: 210 + marginTopHeight, y2: 210 + marginTopHeight },
            { ...lineConfig, y1: 225 + marginTopHeight, y2: 225 + marginTopHeight },
            { ...lineConfig, y1: 240 + marginTopHeight, y2: 240 + marginTopHeight },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 50, x1: 27.5, x2: 27.5, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 55, x2: 55, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 82.5, x2: 82.5, },
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 45 + marginTopHeight, x1: 62.5, x2: 62.5 },
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 45 + marginTopHeight, x1: 90, x2: 90 },
            { ...lineConfig, y1: 136 + marginTopHeight, y2: 151 + marginTopHeight, x1: 28.5, x2: 0 },
            //标题
            { ...titleConfig, y: 20, text: '安方连云港分公司珠江路仓库物资卡片', height: 30, width: 100, x: 5, fontHeight: 8.5, },
            { ...titleConfig, y: 50, text: '物料编码' },
            { ...titleConfig, y: 50, text: '计量单位', x: 62.5 },
            { ...titleConfig, y: 65, text: '批次号', },
            { ...titleConfig, y: 80, text: '物料描述', height: 30 },
            { ...titleConfig, y: 110, text: '供应商', },
            { ...titleConfig, y: 125, text: '备注', height: 30, },
            { ...titleConfig, y: 157, text: '日期', height: 15, verticalAlignment: 0, horizontalAlignment: 0, fontHeight: 6 },
            { ...titleConfig, y: 155, text: params.date?.split('-')[0] || new Date().getFullYear() + '', height: 15, verticalAlignment: 2, horizontalAlignment: 2 },
            { ...titleConfig, y: 155, x: 27.5, text: '入库数量', height: 15, },
            { ...titleConfig, y: 155, x: 55, text: '出库数量', height: 15, },
            { ...titleConfig, y: 155, x: 82.5, text: '库存数量', height: 15, },
            //内容
            { ...textConfig, y: 50, x: 27.5, width: 35, text: params.wlbm || '', },
            { ...textConfig, y: 65, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 80, text: params.wlms || '', height: 30, },
            { ...textConfig, y: 50, x: 90, width: 20, text: params.dddw || '', },
            // { ...textConfig, y: 110, text: params.num + '' || '', fontHeight: 8.5 },
            { ...textConfig, y: 110, text: params.gysmc || '' },
            { ...textConfig, y: 125, text: params.remarks || '', height: 30, },
            { ...textConfig, y: 170, x: 0, width: 27.5, text: params.date?.split('-').filter((item, index) => index !== 0).join('/') || '', height: 15, fontHeight: 8.5 },
            { ...textConfig, y: 170, x: 27.5, width: 27.5, text: (params.numberDisks || '') + '', height: 15, },
            { ...textConfig, y: 170, x: 55, width: 27.5, text: (params.quantityIssued || '') + '', height: 15, },
            { ...textConfig, y: 170, x: 82.5, width: 27.5, text: (params.balanceQuantity || '') + '', height: 15, },
        ]);
    },

    'lygThree': (params) => {
        let printWidth = 110;
        let printHeight = 275;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;

        //线条通用配置
        let lineConfig = {
            type: 'line',// 类型
            lineWidth: 1,// 线宽
            x1: 0,// x轴起点
            x2: printWidth,// x轴终点
        };

        //标题通用配置
        let titleConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 27.5, // 区域宽度
            height: 15,// 区域高度
        };

        //内容通用配置
        let textConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 82.5,// 区域宽度
            height: 15,// 区域高度
            x: 27.5,// x轴起点
        };

        function generateLabelCode(code) {
            // Concatenate the parts of the label code
            const labelCode = code + "ZYCK" + generateFormattedDate() + generateSerialNumber();
            return labelCode;
        }
        // Define a method to generate the formatted date
        function generateFormattedDate() {
            // Get the current date
            const currentDate = new Date();
            // Extract year, month, and day
            const year = currentDate.getFullYear();
            const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
            const day = currentDate.getDate().toString().padStart(2, '0');

            // Format date as yyyyMMdd
            return `${year}${month}${day}`;
        }
        // Define a method to generate the serial number
        function generateSerialNumber() {
            // Generate a random number between 0 and 9999
            const randomNumber = Math.floor(Math.random() * 10000);
            // Format as a 4-digit number
            return randomNumber.toString().padStart(4, '0');
        }

        let paramsCode = generateLabelCode(params.gc);

        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 30 + marginTopHeight },
            { ...lineConfig, y1: 45 + marginTopHeight, y2: 45 + marginTopHeight },
            { ...lineConfig, y1: 60 + marginTopHeight, y2: 60 + marginTopHeight },
            { ...lineConfig, y1: 90 + marginTopHeight, y2: 90 + marginTopHeight },
            { ...lineConfig, y1: 105 + marginTopHeight, y2: 105 + marginTopHeight },
            { ...lineConfig, y1: 120 + marginTopHeight, y2: 120 + marginTopHeight },
            { ...lineConfig, y1: 135 + marginTopHeight, y2: 135 + marginTopHeight },
            { ...lineConfig, y1: 150 + marginTopHeight, y2: 150 + marginTopHeight },
            { ...lineConfig, y1: 195 + marginTopHeight, y2: 195 + marginTopHeight },
            // { ...lineConfig, y1: 195 + marginTopHeight, y2: 195 + marginTopHeight },
            // { ...lineConfig, y1: 210 + marginTopHeight, y2: 210 + marginTopHeight },
            { ...lineConfig, y1: 225 + marginTopHeight, y2: 225 + marginTopHeight },
            // { ...lineConfig, y1: 240 + marginTopHeight, y2: 240 + marginTopHeight },
            { ...lineConfig, y1: 150 + marginTopHeight, y2: 50, x1: 27.5, x2: 27.5, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 245, x1: 27.5, x2: 27.5, },
            // { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 55, x2: 55, },
            // { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 82.5, x2: 82.5, },
            // { ...lineConfig, y1: 135 + marginTopHeight, y2: 150 + marginTopHeight ,x1:62.5,x2:62.5},
            // { ...lineConfig, y1: 135 + marginTopHeight, y2: 150 + marginTopHeight ,x1:90,x2:90},
            // { ...lineConfig, y1: 136 + marginTopHeight, y2: 151 + marginTopHeight ,x1:28.5,x2:0},
            //标题
            { ...titleConfig, y: 20, text: '灌云供电公司主业仓库物资卡片', height: 30, width: 100, x: 5, fontHeight: 11, },
            { ...titleConfig, y: 50, text: '物料编码' },

            { ...titleConfig, y: 65, text: '批次号', },
            { ...titleConfig, y: 80, text: '物料描述', height: 30 },
            { ...titleConfig, y: 110, text: '供应商', },
            // { ...titleConfig, y: 125, text: '备注', height: 30, },                              
            { ...titleConfig, y: 125, text: '实物数量', height: 15 },
            // { ...titleConfig, y: 155, text: '计量单位', x:62.5},                                                     
            { ...titleConfig, y: 140, text: '计量单位', height: 15, },
            { ...titleConfig, y: 155, text: '入库日期', height: 15, },
            // { ...titleConfig, y: 185, text: '库位', height: 15, },  
            { ...titleConfig, y: 245, text: '备注', height: 30, },
            //内容
            { ...textConfig, y: 50, text: params.wlbm || '', },
            { ...textConfig, y: 65, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 80, text: params.wlms || '', height: 30, },
            { ...textConfig, y: 110, text: params.gysmc || '' },
            // { ...textConfig, y: 125, text: params.remark || '', height: 30, },
            { ...textConfig, y: 125, text: (params.htsl ?? '') + '' || '', height: 15, },
            { ...textConfig, y: 140, text: (params.dddw ?? '') + '', height: 15, },
            { ...textConfig, y: 155, text: ((params.createTime ?? '') + ''), height: 15, },
            // { ...textConfig, y: 185,x:27.5, text: (('2a-4b-6c'??'')+''), height: 15, },
            { type: 'qrcode', text: paramsCode || '', x: 37, y: 174.5, width: 36, eccLevel: 1 },
            { type: "barcode", text: paramsCode || '', x: 17, y: 220, width: 76, height: 20, textHeight: 6, textAlignment: 3, },
            // { type: 'image', imageFile: params.qrCode||'', x: 35, y: 172.5, width: 40, height: 40 },
            // { type: 'image', imageFile: params.barCode||'', x: 2.5, y: 220, width: 105, height: 20 },
            { ...textConfig, y: 245, text: params.remarks || '', height: 30, },
        ]);
    },

    'lygFour': (params) => {
        let printWidth = 110;
        let printHeight = 275;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;

        //线条通用配置
        let lineConfig = {
            type: 'line',// 类型
            lineWidth: 1,// 线宽
            x1: 0,// x轴起点
            x2: printWidth,// x轴终点
        };

        //标题通用配置
        let titleConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 27.5, // 区域宽度
            height: 15,// 区域高度
        };

        //内容通用配置
        let textConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 82.5,// 区域宽度
            height: 15,// 区域高度
            x: 27.5,// x轴起点
        };

        function generateLabelCode(code) {
            // Concatenate the parts of the label code
            const labelCode = code + "ZHYC" + generateFormattedDate() + generateSerialNumber();
            return labelCode;
        }
        // Define a method to generate the formatted date
        function generateFormattedDate() {
            // Get the current date
            const currentDate = new Date();
            // Extract year, month, and day
            const year = currentDate.getFullYear();
            const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
            const day = currentDate.getDate().toString().padStart(2, '0');

            // Format date as yyyyMMdd
            return `${year}${month}${day}`;
        }
        // Define a method to generate the serial number
        function generateSerialNumber() {
            // Generate a random number between 0 and 9999
            const randomNumber = Math.floor(Math.random() * 10000);
            // Format as a 4-digit number
            return randomNumber.toString().padStart(4, '0');
        }

        let paramsCode = generateLabelCode(params.gc);

        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 30 + marginTopHeight },
            { ...lineConfig, y1: 45 + marginTopHeight, y2: 45 + marginTopHeight },
            { ...lineConfig, y1: 60 + marginTopHeight, y2: 60 + marginTopHeight },
            { ...lineConfig, y1: 90 + marginTopHeight, y2: 90 + marginTopHeight },
            { ...lineConfig, y1: 105 + marginTopHeight, y2: 105 + marginTopHeight },
            { ...lineConfig, y1: 120 + marginTopHeight, y2: 120 + marginTopHeight },
            { ...lineConfig, y1: 135 + marginTopHeight, y2: 135 + marginTopHeight },
            { ...lineConfig, y1: 165 + marginTopHeight, y2: 165 + marginTopHeight },
            { ...lineConfig, y1: 210 + marginTopHeight, y2: 210 + marginTopHeight },
            // { ...lineConfig, y1: 195 + marginTopHeight, y2: 195 + marginTopHeight },
            // { ...lineConfig, y1: 210 + marginTopHeight, y2: 210 + marginTopHeight },
            { ...lineConfig, y1: 240 + marginTopHeight, y2: 240 + marginTopHeight },
            // { ...lineConfig, y1: 240 + marginTopHeight, y2: 240 + marginTopHeight },
            { ...lineConfig, y1: 165 + marginTopHeight, y2: 50, x1: 27.5, x2: 27.5, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 260, x1: 27.5, x2: 27.5, },
            // { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 55, x2: 55, },
            // { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 82.5, x2: 82.5, },
            // { ...lineConfig, y1: 135 + marginTopHeight, y2: 150 + marginTopHeight ,x1:62.5,x2:62.5},
            // { ...lineConfig, y1: 135 + marginTopHeight, y2: 150 + marginTopHeight ,x1:90,x2:90},
            // { ...lineConfig, y1: 136 + marginTopHeight, y2: 151 + marginTopHeight ,x1:28.5,x2:0},
            //标题
            { ...titleConfig, y: 20, text: '灌云供电公司专业仓物资卡片', height: 30, width: 100, x: 5, fontHeight: 10, },
            { ...titleConfig, y: 50, text: '物料编码' },

            { ...titleConfig, y: 65, text: '批次号', },
            { ...titleConfig, y: 80, text: '物料描述', height: 30 },
            { ...titleConfig, y: 110, text: '需求部门', },
            // { ...titleConfig, y: 125, text: '备注', height: 30, },                              
            { ...titleConfig, y: 125, text: '实物数量', height: 15 },
            // { ...titleConfig, y: 155, text: '计量单位', x:62.5},                                                     
            { ...titleConfig, y: 140, text: '计量单位', height: 15, },
            { ...titleConfig, y: 155, text: '项目名称', height: 30, },
            // { ...titleConfig, y: 185, text: '库位', height: 15, },  
            { ...titleConfig, y: 260, text: '备注', height: 15, },
            //内容
            { ...textConfig, y: 50, text: params.wlbm || '', },
            { ...textConfig, y: 65, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 80, text: params.wlms || '', height: 30, },
            { ...textConfig, y: 110, text: params.demandDepartment || '' },
            // { ...textConfig, y: 125, text: params.remark || '', height: 30, },
            { ...textConfig, y: 125, text: (params.htsl ?? '') + '' || '', height: 15, },
            { ...textConfig, y: 140, text: (params.dddw ?? '') + '', height: 15, },
            { ...textConfig, y: 155, text: ((params.entryName ?? '') + ''), height: 30, },
            // { ...textConfig, y: 185,x:27.5, text: (('2a-4b-6c'??'')+''), height: 15, },
            { type: 'qrcode', text: paramsCode || '', x: 37, y: 189.5, width: 36, eccLevel: 1 },
            { type: "barcode", text: paramsCode || '', x: 17, y: 235, width: 76, height: 20, textHeight: 6, textAlignment: 3, },
            // { type: 'image', imageFile: params.qrCode||'', x: 35, y: 172.5, width: 40, height: 40 },
            // { type: 'image', imageFile: params.barCode||'', x: 2.5, y: 220, width: 105, height: 20 },
            { ...textConfig, y: 260, text: params.remarks || '', height: 15, },
        ]);
    },

    'lygFive': (params) => {
        let printWidth = 110;
        let printHeight = 275;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;

        //线条通用配置
        let lineConfig = {
            type: 'line',// 类型
            lineWidth: 1,// 线宽
            x1: 0,// x轴起点
            x2: printWidth,// x轴终点
        };

        //标题通用配置
        let titleConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 27.5, // 区域宽度
            height: 15,// 区域高度
        };

        //内容通用配置
        let textConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 82.5,// 区域宽度
            height: 15,// 区域高度
            x: 27.5,// x轴起点
        };

        function generateLabelCode(code) {
            // Concatenate the parts of the label code
            const labelCode = code + "CYCK" + generateFormattedDate() + generateSerialNumber();
            return labelCode;
        }
        // Define a method to generate the formatted date
        function generateFormattedDate() {
            // Get the current date
            const currentDate = new Date();
            // Extract year, month, and day
            const year = currentDate.getFullYear();
            const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
            const day = currentDate.getDate().toString().padStart(2, '0');

            // Format date as yyyyMMdd
            return `${year}${month}${day}`;
        }
        // Define a method to generate the serial number
        function generateSerialNumber() {
            // Generate a random number between 0 and 9999
            const randomNumber = Math.floor(Math.random() * 10000);
            // Format as a 4-digit number
            return randomNumber.toString().padStart(4, '0');
        }

        let paramsCode = generateLabelCode(params.gc);

        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 30 + marginTopHeight },
            { ...lineConfig, y1: 45 + marginTopHeight, y2: 45 + marginTopHeight },
            { ...lineConfig, y1: 60 + marginTopHeight, y2: 60 + marginTopHeight },
            { ...lineConfig, y1: 90 + marginTopHeight, y2: 90 + marginTopHeight },
            { ...lineConfig, y1: 105 + marginTopHeight, y2: 105 + marginTopHeight },
            { ...lineConfig, y1: 120 + marginTopHeight, y2: 120 + marginTopHeight },
            { ...lineConfig, y1: 135 + marginTopHeight, y2: 135 + marginTopHeight },
            { ...lineConfig, y1: 165 + marginTopHeight, y2: 165 + marginTopHeight },
            { ...lineConfig, y1: 210 + marginTopHeight, y2: 210 + marginTopHeight },
            // { ...lineConfig, y1: 195 + marginTopHeight, y2: 195 + marginTopHeight },
            // { ...lineConfig, y1: 210 + marginTopHeight, y2: 210 + marginTopHeight },
            { ...lineConfig, y1: 240 + marginTopHeight, y2: 240 + marginTopHeight },
            // { ...lineConfig, y1: 240 + marginTopHeight, y2: 240 + marginTopHeight },
            { ...lineConfig, y1: 165 + marginTopHeight, y2: 50, x1: 27.5, x2: 27.5, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 260, x1: 27.5, x2: 27.5, },
            // { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 55, x2: 55, },
            // { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 82.5, x2: 82.5, },
            // { ...lineConfig, y1: 135 + marginTopHeight, y2: 150 + marginTopHeight ,x1:62.5,x2:62.5},
            // { ...lineConfig, y1: 135 + marginTopHeight, y2: 150 + marginTopHeight ,x1:90,x2:90},
            // { ...lineConfig, y1: 136 + marginTopHeight, y2: 151 + marginTopHeight ,x1:28.5,x2:0},
            //标题
            { ...titleConfig, y: 20, text: '灌云供电公司产业仓库物资卡片', height: 30, width: 100, x: 5, fontHeight: 10.5, },
            { ...titleConfig, y: 50, text: '物料编码' },

            { ...titleConfig, y: 65, text: '批次号', },
            { ...titleConfig, y: 80, text: '物料描述', height: 30 },
            { ...titleConfig, y: 110, text: '需求部门', },
            // { ...titleConfig, y: 125, text: '备注', height: 30, },                              
            { ...titleConfig, y: 125, text: '实物数量', height: 15 },
            // { ...titleConfig, y: 155, text: '计量单位', x:62.5},                                                     
            { ...titleConfig, y: 140, text: '计量单位', height: 15, },
            { ...titleConfig, y: 155, text: '项目名称', height: 30, },
            // { ...titleConfig, y: 185, text: '库位', height: 15, },  
            { ...titleConfig, y: 260, text: '备注', height: 15, },
            //内容
            { ...textConfig, y: 50, text: params.wlbm || '', },
            { ...textConfig, y: 65, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 80, text: params.wlms || '', height: 30, },
            { ...textConfig, y: 110, text: params.demandDepartment || '' },
            // { ...textConfig, y: 125, text: params.remark || '', height: 30, },
            { ...textConfig, y: 125, text: (params.htsl ?? '') + '' || '', height: 15, },
            { ...textConfig, y: 140, text: (params.dddw ?? '') + '', height: 15, },
            { ...textConfig, y: 155, text: ((params.entryName ?? '') + ''), height: 30, },
            // { ...textConfig, y: 185,x:27.5, text: (('2a-4b-6c'??'')+''), height: 15, },
            { type: 'qrcode', text: paramsCode || '', x: 37, y: 189.5, width: 36, eccLevel: 1 },
            { type: "barcode", text: paramsCode || '', x: 17, y: 235, width: 76, height: 20, textHeight: 6, textAlignment: 3, },
            // { type: 'image', imageFile: params.qrCode||'', x: 35, y: 172.5, width: 40, height: 40 },
            // { type: 'image', imageFile: params.barCode||'', x: 2.5, y: 220, width: 105, height: 20 },
            { ...textConfig, y: 260, text: params.remarks || '', height: 15, },
        ]);
    },

    'lygSix': (params) => {
        let printWidth = 110;
        let printHeight = 185;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;
        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { type: 'line', x1: 0, y1: 30 + marginTopHeight, x2: printWidth, y2: 30 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 45 + marginTopHeight, x2: printWidth, y2: 45 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 60 + marginTopHeight, x2: printWidth, y2: 60 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 90 + marginTopHeight, x2: printWidth, y2: 90 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 105 + marginTopHeight, x2: printWidth, y2: 105 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 120 + marginTopHeight, x2: printWidth, y2: 120 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 135 + marginTopHeight, x2: printWidth, y2: 135 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 150 + marginTopHeight, x2: printWidth, y2: 150 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 30, y1: 165 + marginTopHeight, x2: 30, y2: 50, lineWidth: 1 },
            //标题
            { type: 'text', text: '灌云供电公司专业仓\n物资卡片', width: 110, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 20, fontStyle: 1, fontHeight: 9 },
            { type: 'text', text: '物料编码', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 50, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '批次号', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 65, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '物料描述', width: 30, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 80, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '计量单位', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 110, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '物资数量', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 125, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '库位', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 140, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '供应商', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 155, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '备注', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 170, fontStyle: 1, fontHeight: 6.5 },
            //内容
            { type: 'text', text: params.wlbm || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 50, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.pc || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 65, x: 30, fontStyle: 1, fontHeight: 8.5 },
            { type: 'text', text: params.wlms || '', width: 80, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 80, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.dddw || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 110, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: (params.materialsNum ?? '') + '' || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 125, x: 30, fontStyle: 1, fontHeight: 8.5 },
            { type: 'text', text: params.storageLocationProject || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 140, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.gysmc || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 155, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.remarks || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 170, x: 30, fontStyle: 1, fontHeight: 6 },
        ]);
    },

    'lygSeven': (params) => {
        let printWidth = 110;
        let printHeight = 185;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;
        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { type: 'line', x1: 0, y1: 30 + marginTopHeight, x2: printWidth, y2: 30 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 45 + marginTopHeight, x2: printWidth, y2: 45 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 60 + marginTopHeight, x2: printWidth, y2: 60 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 90 + marginTopHeight, x2: printWidth, y2: 90 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 105 + marginTopHeight, x2: printWidth, y2: 105 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 120 + marginTopHeight, x2: printWidth, y2: 120 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 135 + marginTopHeight, x2: printWidth, y2: 135 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 150 + marginTopHeight, x2: printWidth, y2: 150 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 30, y1: 165 + marginTopHeight, x2: 30, y2: 50, lineWidth: 1 },
            //标题
            { type: 'text', text: '灌云供电公司主业仓库\n物资卡片', width: 110, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 20, fontStyle: 1, fontHeight: 9 },
            { type: 'text', text: '物料编码', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 50, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '批次号', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 65, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '物料描述', width: 30, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 80, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '计量单位', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 110, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '物资数量', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 125, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '库位', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 140, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '供应商', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 155, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '备注', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 170, fontStyle: 1, fontHeight: 6.5 },
            //内容
            { type: 'text', text: params.wlbm || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 50, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.pc || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 65, x: 30, fontStyle: 1, fontHeight: 8.5 },
            { type: 'text', text: params.wlms || '', width: 80, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 80, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.dddw || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 110, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: (params.materialsNum ?? '') + '' || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 125, x: 30, fontStyle: 1, fontHeight: 8.5 },
            { type: 'text', text: params.storageLocationProject || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 140, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.gysmc || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 155, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.remarks || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 170, x: 30, fontStyle: 1, fontHeight: 6 },
        ]);
    },

    'lygEight': (params) => {
        let printWidth = 110;
        let printHeight = 185;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;
        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { type: 'line', x1: 0, y1: 30 + marginTopHeight, x2: printWidth, y2: 30 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 45 + marginTopHeight, x2: printWidth, y2: 45 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 60 + marginTopHeight, x2: printWidth, y2: 60 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 90 + marginTopHeight, x2: printWidth, y2: 90 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 105 + marginTopHeight, x2: printWidth, y2: 105 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 120 + marginTopHeight, x2: printWidth, y2: 120 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 135 + marginTopHeight, x2: printWidth, y2: 135 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 150 + marginTopHeight, x2: printWidth, y2: 150 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 30, y1: 165 + marginTopHeight, x2: 30, y2: 50, lineWidth: 1 },
            //标题
            { type: 'text', text: '灌云供电公司产业仓库\n物资卡片', width: 110, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 20, fontStyle: 1, fontHeight: 9 },
            { type: 'text', text: '物料编码', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 50, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '批次号', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 65, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '物料描述', width: 30, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 80, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '计量单位', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 110, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '物资数量', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 125, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '库位', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 140, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '供应商', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 155, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '备注', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 170, fontStyle: 1, fontHeight: 6.5 },
            //内容
            { type: 'text', text: params.wlbm || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 50, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.pc || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 65, x: 30, fontStyle: 1, fontHeight: 8.5 },
            { type: 'text', text: params.wlms || '', width: 80, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 80, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.dddw || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 110, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: (params.materialsNum ?? '') + '' || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 125, x: 30, fontStyle: 1, fontHeight: 8.5 },
            { type: 'text', text: params.storageLocationProject || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 140, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.gysmc || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 155, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.remarks || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 170, x: 30, fontStyle: 1, fontHeight: 6 },
        ]);
    },

    'lygNine': (params) => {
        let printWidth = 110;
        let printHeight = 185;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;
        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { type: 'line', x1: 0, y1: 30 + marginTopHeight, x2: printWidth, y2: 30 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 45 + marginTopHeight, x2: printWidth, y2: 45 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 60 + marginTopHeight, x2: printWidth, y2: 60 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 90 + marginTopHeight, x2: printWidth, y2: 90 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 105 + marginTopHeight, x2: printWidth, y2: 105 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 120 + marginTopHeight, x2: printWidth, y2: 120 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 135 + marginTopHeight, x2: printWidth, y2: 135 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 150 + marginTopHeight, x2: printWidth, y2: 150 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 30, y1: 165 + marginTopHeight, x2: 30, y2: 50, lineWidth: 1 },
            //标题
            { type: 'text', text: '东海县供电公司物资卡片', width: 110, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 20, fontStyle: 1, fontHeight: 9 },
            { type: 'text', text: '物料编码', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 50, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '批次号', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 65, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '物料描述', width: 30, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 80, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '计量单位', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 110, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '物资数量', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 125, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '库位', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 140, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '供应商', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 155, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '备注', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 170, fontStyle: 1, fontHeight: 6.5 },
            //内容
            { type: 'text', text: params.wlbm || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 50, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.pc || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 65, x: 30, fontStyle: 1, fontHeight: 8.5 },
            { type: 'text', text: params.wlms || '', width: 80, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 80, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.dddw || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 110, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: (params.materialsNum ?? '') + '' || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 125, x: 30, fontStyle: 1, fontHeight: 8.5 },
            { type: 'text', text: params.storageLocationProject || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 140, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.gysmc || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 155, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.remarks || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 170, x: 30, fontStyle: 1, fontHeight: 6 },
        ]);
    },

    'lyg-gn-1': (params) => {
        let printWidth = 110;
        let printHeight = 185;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;
        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { type: 'line', x1: 0, y1: 30 + marginTopHeight, x2: printWidth, y2: 30 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 45 + marginTopHeight, x2: printWidth, y2: 45 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 60 + marginTopHeight, x2: printWidth, y2: 60 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 90 + marginTopHeight, x2: printWidth, y2: 90 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 105 + marginTopHeight, x2: printWidth, y2: 105 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 120 + marginTopHeight, x2: printWidth, y2: 120 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 135 + marginTopHeight, x2: printWidth, y2: 135 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 0, y1: 150 + marginTopHeight, x2: printWidth, y2: 150 + marginTopHeight, lineWidth: 1 },
            { type: 'line', x1: 30, y1: 165 + marginTopHeight, x2: 30, y2: 50, lineWidth: 1 },
            //标题
            { type: 'text', text: '灌南县供电公司物资卡片', width: 110, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 20, fontStyle: 1, fontHeight: 9 },
            { type: 'text', text: '物料编码', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 50, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '批次号', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 65, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '物料描述', width: 30, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 80, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '计量单位', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 110, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '物资数量', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 125, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '库位', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 140, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '供应商', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 155, fontStyle: 1, fontHeight: 6.5 },
            { type: 'text', text: '备注', width: 30, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 170, fontStyle: 1, fontHeight: 6.5 },
            //内容
            { type: 'text', text: params.wlbm || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 50, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.pc || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 65, x: 30, fontStyle: 1, fontHeight: 8.5 },
            { type: 'text', text: params.wlms || '', width: 80, height: 30, verticalAlignment: 1, horizontalAlignment: 1, y: 80, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.dddw || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 110, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: (params.materialsNum ?? '') + '' || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 125, x: 30, fontStyle: 1, fontHeight: 8.5 },
            { type: 'text', text: params.storageLocationProject || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 140, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.gysmc || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 155, x: 30, fontStyle: 1, fontHeight: 6 },
            { type: 'text', text: params.remarks || '', width: 80, height: 15, verticalAlignment: 1, horizontalAlignment: 1, y: 170, x: 30, fontStyle: 1, fontHeight: 6 },
        ]);
    },

    'lyg-gn-2': (params) => {
        let printWidth = 110;
        let printHeight = 275;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;

        //线条通用配置
        let lineConfig = {
            type: 'line',// 类型
            lineWidth: 1,// 线宽
            x1: 0,// x轴起点
            x2: printWidth,// x轴终点
        };

        //标题通用配置
        let titleConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 27.5, // 区域宽度
            height: 15,// 区域高度
        };

        //内容通用配置
        let textConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 82.5,// 区域宽度
            height: 15,// 区域高度
            x: 27.5,// x轴起点
        };
        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 30 + marginTopHeight },
            { ...lineConfig, y1: 45 + marginTopHeight, y2: 45 + marginTopHeight },
            { ...lineConfig, y1: 60 + marginTopHeight, y2: 60 + marginTopHeight },
            { ...lineConfig, y1: 90 + marginTopHeight, y2: 90 + marginTopHeight },
            { ...lineConfig, y1: 105 + marginTopHeight, y2: 105 + marginTopHeight },
            { ...lineConfig, y1: 135 + marginTopHeight, y2: 135 + marginTopHeight },
            { ...lineConfig, y1: 150 + marginTopHeight, y2: 150 + marginTopHeight },
            { ...lineConfig, y1: 165 + marginTopHeight, y2: 165 + marginTopHeight },
            { ...lineConfig, y1: 180 + marginTopHeight, y2: 180 + marginTopHeight },
            { ...lineConfig, y1: 195 + marginTopHeight, y2: 195 + marginTopHeight },
            { ...lineConfig, y1: 210 + marginTopHeight, y2: 210 + marginTopHeight },
            { ...lineConfig, y1: 225 + marginTopHeight, y2: 225 + marginTopHeight },
            { ...lineConfig, y1: 240 + marginTopHeight, y2: 240 + marginTopHeight },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 50, x1: 27.5, x2: 27.5, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 55, x2: 55, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 82.5, x2: 82.5, },
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 45 + marginTopHeight, x1: 62.5, x2: 62.5 },
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 45 + marginTopHeight, x1: 90, x2: 90 },
            { ...lineConfig, y1: 136 + marginTopHeight, y2: 151 + marginTopHeight, x1: 28.5, x2: 0 },
            //标题
            { ...titleConfig, y: 20, text: '灌南县供电公司仓库\n物资卡片', height: 30, width: 100, x: 5, fontHeight: 8.5, },
            { ...titleConfig, y: 50, text: '物料编码' },
            { ...titleConfig, y: 50, text: '计量单位', x: 62.5 },
            { ...titleConfig, y: 65, text: '批次号', },
            { ...titleConfig, y: 80, text: '物料描述', height: 30 },
            { ...titleConfig, y: 110, text: '供应商', },
            { ...titleConfig, y: 125, text: '备注', height: 30, },
            { ...titleConfig, y: 157, text: '日期', height: 15, verticalAlignment: 0, horizontalAlignment: 0, fontHeight: 6 },
            { ...titleConfig, y: 155, text: params.date?.split('-')[0] || new Date().getFullYear() + '', height: 15, verticalAlignment: 2, horizontalAlignment: 2 },
            { ...titleConfig, y: 155, x: 27.5, text: '入库数量', height: 15, },
            { ...titleConfig, y: 155, x: 55, text: '出库数量', height: 15, },
            { ...titleConfig, y: 155, x: 82.5, text: '库存数量', height: 15, },
            //内容
            { ...textConfig, y: 50, x: 27.5, width: 35, text: params.wlbm || '', },
            { ...textConfig, y: 65, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 80, text: params.wlms || '', height: 30, },
            { ...textConfig, y: 50, x: 90, width: 20, text: params.dddw || '', },
            // { ...textConfig, y: 110, text: params.num + '' || '', fontHeight: 8.5 },
            { ...textConfig, y: 110, text: params.gysmc || '' },
            { ...textConfig, y: 125, text: params.remarks || '', height: 30, },
            { ...textConfig, y: 170, x: 0, width: 27.5, text: params.date?.split('-').filter((item, index) => index !== 0).join('/') || '', height: 15, fontHeight: 8.5 },
            { ...textConfig, y: 170, x: 27.5, width: 27.5, text: (params.numberDisks || '') + '', height: 15, },
            { ...textConfig, y: 170, x: 55, width: 27.5, text: (params.quantityIssued || '') + '', height: 15, },
            { ...textConfig, y: 170, x: 82.5, width: 27.5, text: (params.balanceQuantity || '') + '', height: 15, },
        ]);
    },

    'lyg-dh-2': (params) => {
        let printWidth = 110;
        let printHeight = 275;
        let marginTopHeight = 20;
        let contentHeight = printHeight - marginTopHeight;

        //线条通用配置
        let lineConfig = {
            type: 'line',// 类型
            lineWidth: 1,// 线宽
            x1: 0,// x轴起点
            x2: printWidth,// x轴终点
        };

        //标题通用配置
        let titleConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 27.5, // 区域宽度
            height: 15,// 区域高度
        };

        //内容通用配置
        let textConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 82.5,// 区域宽度
            height: 15,// 区域高度
            x: 27.5,// x轴起点
        };
        return ([
            //矩形
            {
                type: "rectangle",
                width: printWidth,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight
            },
            //线条
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 30 + marginTopHeight },
            { ...lineConfig, y1: 45 + marginTopHeight, y2: 45 + marginTopHeight },
            { ...lineConfig, y1: 60 + marginTopHeight, y2: 60 + marginTopHeight },
            { ...lineConfig, y1: 90 + marginTopHeight, y2: 90 + marginTopHeight },
            { ...lineConfig, y1: 105 + marginTopHeight, y2: 105 + marginTopHeight },
            { ...lineConfig, y1: 135 + marginTopHeight, y2: 135 + marginTopHeight },
            { ...lineConfig, y1: 150 + marginTopHeight, y2: 150 + marginTopHeight },
            { ...lineConfig, y1: 165 + marginTopHeight, y2: 165 + marginTopHeight },
            { ...lineConfig, y1: 180 + marginTopHeight, y2: 180 + marginTopHeight },
            { ...lineConfig, y1: 195 + marginTopHeight, y2: 195 + marginTopHeight },
            { ...lineConfig, y1: 210 + marginTopHeight, y2: 210 + marginTopHeight },
            { ...lineConfig, y1: 225 + marginTopHeight, y2: 225 + marginTopHeight },
            { ...lineConfig, y1: 240 + marginTopHeight, y2: 240 + marginTopHeight },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 50, x1: 27.5, x2: 27.5, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 55, x2: 55, },
            { ...lineConfig, y1: 255 + marginTopHeight, y2: 155, x1: 82.5, x2: 82.5, },
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 45 + marginTopHeight, x1: 62.5, x2: 62.5 },
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 45 + marginTopHeight, x1: 90, x2: 90 },
            { ...lineConfig, y1: 136 + marginTopHeight, y2: 151 + marginTopHeight, x1: 28.5, x2: 0 },
            //标题
            { ...titleConfig, y: 20, text: '东海县供电公司仓库\n物资卡片', height: 30, width: 100, x: 5, fontHeight: 8.5, },
            { ...titleConfig, y: 50, text: '物料编码' },
            { ...titleConfig, y: 50, text: '计量单位', x: 62.5 },
            { ...titleConfig, y: 65, text: '批次号', },
            { ...titleConfig, y: 80, text: '物料描述', height: 30 },
            { ...titleConfig, y: 110, text: '供应商', },
            { ...titleConfig, y: 125, text: '备注', height: 30, },
            { ...titleConfig, y: 157, text: '日期', height: 15, verticalAlignment: 0, horizontalAlignment: 0, fontHeight: 6 },
            { ...titleConfig, y: 155, text: params.date?.split('-')[0] || new Date().getFullYear() + '', height: 15, verticalAlignment: 2, horizontalAlignment: 2 },
            { ...titleConfig, y: 155, x: 27.5, text: '入库数量', height: 15, },
            { ...titleConfig, y: 155, x: 55, text: '出库数量', height: 15, },
            { ...titleConfig, y: 155, x: 82.5, text: '库存数量', height: 15, },
            //内容
            { ...textConfig, y: 50, x: 27.5, width: 35, text: params.wlbm || '', },
            { ...textConfig, y: 65, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 80, text: params.wlms || '', height: 30, },
            { ...textConfig, y: 50, x: 90, width: 20, text: params.dddw || '', },
            // { ...textConfig, y: 110, text: params.num + '' || '', fontHeight: 8.5 },
            { ...textConfig, y: 110, text: params.gysmc || '' },
            { ...textConfig, y: 125, text: params.remarks || '', height: 30, },
            { ...textConfig, y: 170, x: 0, width: 27.5, text: params.date?.split('-').filter((item, index) => index !== 0).join('/') || '', height: 15, fontHeight: 8.5 },
            { ...textConfig, y: 170, x: 27.5, width: 27.5, text: (params.numberDisks || '') + '', height: 15, },
            { ...textConfig, y: 170, x: 55, width: 27.5, text: (params.quantityIssued || '') + '', height: 15, },
            { ...textConfig, y: 170, x: 82.5, width: 27.5, text: (params.balanceQuantity || '') + '', height: 15, },
        ]);
    },

    'lyg-gn-szl-1': (params) => {//88*1.5-2,190*1.5-2
        let printWidth = 283;
        let printHeight = 130;
        let marginTopHeight = 10;
        let marginTopWidth = 11.5;
        let contentHeight = printHeight - marginTopHeight;

        //线条通用配置
        let lineConfig = {
            type: 'line',// 类型
            lineWidth: 1,// 线宽
            x1: marginTopWidth,// x轴起点
            x2: marginTopWidth + 260,// x轴终点
        };

        //标题通用配置
        let titleConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 30, // 区域宽度
            height: 15,// 区域高度
            x: marginTopWidth,// x轴起点
        };

        //内容通用配置
        let textConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 100,// 区域宽度
            height: 15,// 区域高度
            x: marginTopWidth + 30,// x轴起点
        };
        return ([
            //矩形
            {
                type: "rectangle",
                width: 260,
                height: contentHeight,
                lineWidth: 1,
                y: marginTopHeight,
                x: marginTopWidth
            },
            // //线条
            { ...lineConfig, y1: 15 + marginTopHeight, y2: 15 + marginTopHeight },
            { ...lineConfig, y1: 30 + marginTopHeight, y2: 30 + marginTopHeight },
            { ...lineConfig, y1: 45 + marginTopHeight, y2: 45 + marginTopHeight },
            { ...lineConfig, y1: 60 + marginTopHeight, y2: 60 + marginTopHeight },
            { ...lineConfig, y1: 75 + marginTopHeight, y2: 75 + marginTopHeight },
            { ...lineConfig, y1: 90 + marginTopHeight, y2: 90 + marginTopHeight },
            { ...lineConfig, y1: 105 + marginTopHeight, y2: 105 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 30, x2: marginTopWidth + 30, y1: 15 + marginTopHeight, y2: 130 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 130, x2: marginTopWidth + 130, y1: 15 + marginTopHeight, y2: 60 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 160, x2: marginTopWidth + 160, y1: 15 + marginTopHeight, y2: 60 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 85, x2: marginTopWidth + 85, y1: 75 + marginTopHeight, y2: 105 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 140, x2: marginTopWidth + 140, y1: 75 + marginTopHeight, y2: 105 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 195, x2: marginTopWidth + 195, y1: 75 + marginTopHeight, y2: 105 + marginTopHeight },
            //标题
            { ...titleConfig, y: 0 + marginTopHeight, text: '灌南县供电公司深圳路仓库物资卡片', height: 15, width: 260, x: marginTopWidth, fontHeight: 8.5, },
            { ...titleConfig, y: 15 + marginTopHeight, text: '物料编码' },
            { ...titleConfig, y: 15 + marginTopHeight, text: '物料描述', x: 130 + marginTopWidth },
            { ...titleConfig, y: 30 + marginTopHeight, text: '仓位' },
            { ...titleConfig, y: 30 + marginTopHeight, text: '批次号', x: 130 + marginTopWidth },
            { ...titleConfig, y: 45 + marginTopHeight, text: '计量单位', },
            { ...titleConfig, y: 45 + marginTopHeight, text: '项目名称', x: 130 + marginTopWidth },
            { ...titleConfig, y: 60 + marginTopHeight, text: '供应商\n名称' },
            { ...titleConfig, y: 75 + marginTopHeight, text: '入库日期' },
            { ...titleConfig, y: 75 + marginTopHeight, text: '收入数量', x: 30 + marginTopWidth, width: 55 },
            { ...titleConfig, y: 75 + marginTopHeight, text: '发出数量', x: 85 + marginTopWidth, width: 55 },
            { ...titleConfig, y: 75 + marginTopHeight, text: '结存数量', x: 140 + marginTopWidth, width: 55 },
            { ...titleConfig, y: 75 + marginTopHeight, text: '本批合计', x: 195 + marginTopWidth, width: 65 },
            { ...titleConfig, y: 105 + marginTopHeight, text: '备注' },
            //内容
            { ...textConfig, y: 15 + marginTopHeight, text: params.wlbm || '' },
            { ...textConfig, y: 15 + marginTopHeight, x: marginTopWidth + 160, text: params.wlms || '' },
            { ...textConfig, y: 30 + marginTopHeight, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 30 + marginTopHeight, x: marginTopWidth + 160, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 45 + marginTopHeight, text: params.dddw || '', },
            { ...textConfig, y: 45 + marginTopHeight, x: marginTopWidth + 160, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 60 + marginTopHeight, text: params.gysmc || '', width: 230 },
            { ...textConfig, y: 90 + marginTopHeight, x: marginTopWidth, width: 30, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 90 + marginTopHeight, x: marginTopWidth + 30, width: 55, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 90 + marginTopHeight, x: marginTopWidth + 85, width: 55, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 90 + marginTopHeight, x: marginTopWidth + 140, width: 55, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 90 + marginTopHeight, x: marginTopWidth + 195, width: 65, text: params.pc || '', fontHeight: 8.5 },
            { ...textConfig, y: 105 + marginTopHeight, width: 230, text: params.remarks || '', fontHeight: 8.5 },
        ]);
    },

    'lyg-gn-szl-2': (params) => {//88*1.5-2,190*1.5-2
        let printWidth = 193;
        let printHeight = 90;
        let marginTopHeight = 5;
        let marginTopWidth = 6.5;
        let contentHeight = printHeight - marginTopHeight;

        //线条通用配置
        let lineConfig = {
            type: 'line',// 类型
            lineWidth: 1,// 线宽
            x1: marginTopWidth,// x轴起点
            x2: marginTopWidth + 180,// x轴终点
        };

        //标题通用配置
        let titleConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 27.5, // 区域宽度
            height: 15,// 区域高度
            x: marginTopWidth,// x轴起点
        };

        //内容通用配置
        let textConfig = {
            type: 'text',// 类型
            verticalAlignment: 1,// 垂直对齐方式
            horizontalAlignment: 1,// 水平对齐方式
            fontStyle: 1,// 字体类型(1为加粗)
            fontHeight: 6,// 字体高度大小
            width: 35,// 区域宽度
            height: 15,// 区域高度
            x: marginTopWidth + 27.5,// x轴起点
        };
        return ([
            //矩形
            {
                type: "rectangle",
                width: 180,
                height: 80,
                lineWidth: 1,
                y: marginTopHeight,
                x: 6.5
            },
            //线条
            { ...lineConfig, y1: 20 + marginTopHeight, y2: 20 + marginTopHeight },
            { ...lineConfig, y1: 35 + marginTopHeight, y2: 35 + marginTopHeight },
            { ...lineConfig, y1: 50 + marginTopHeight, y2: 50 + marginTopHeight },
            { ...lineConfig, y1: 65 + marginTopHeight, y2: 65 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 27.5, x2: marginTopWidth + 27.5, y1: 20 + marginTopHeight, y2: 80 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 62.5, x2: marginTopWidth + 62.5, y1: 20 + marginTopHeight, y2: 35 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 90, x2: marginTopWidth + 90, y1: 20 + marginTopHeight, y2: 35 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 62.5, x2: marginTopWidth + 62.5, y1: 50 + marginTopHeight, y2: 80 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 90, x2: marginTopWidth + 90, y1: 50 + marginTopHeight, y2: 80 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 122.5, x2: marginTopWidth + 122.5, y1: 20 + marginTopHeight, y2: 35 + marginTopHeight },
            { ...lineConfig, x1: marginTopWidth + 150, x2: marginTopWidth + 150, y1: 20 + marginTopHeight, y2: 35 + marginTopHeight },
            //标题
            { ...titleConfig, y: 0 + marginTopHeight, text: '灌南县供电公司物资卡片', height: 20, width: 180, x: marginTopWidth, fontHeight: 8.5, },
            { ...titleConfig, y: 20 + marginTopHeight, text: '物料编码' },
            { ...titleConfig, y: 20 + marginTopHeight, text: '物资数量', x: marginTopWidth + 62.5 },
            { ...titleConfig, y: 20 + marginTopHeight, text: '计量单位', x: marginTopWidth + 122.5 },
            { ...titleConfig, y: 35 + marginTopHeight, text: '物料描述' },
            { ...titleConfig, y: 50 + marginTopHeight, text: '批次号', },
            { ...titleConfig, y: 50 + marginTopHeight, text: '供应商', x: 62.5 + marginTopWidth },
            { ...titleConfig, y: 65 + marginTopHeight, text: '库位' },
            { ...titleConfig, y: 65 + marginTopHeight, text: '备注', x: 62.5 + marginTopWidth },
            //内容
            { ...textConfig, y: 20 + marginTopHeight, text: params.wlbm || '' },
            { ...textConfig, y: 20 + marginTopHeight, x: marginTopWidth + 90, width: 32.5, text: (params.materialsNum ?? '') + '' || '' },
            { ...textConfig, y: 20 + marginTopHeight, x: marginTopWidth + 150, width: 30, text: params.dddw || '' },
            { ...textConfig, y: 35 + marginTopHeight, width: 150, text: params.wlms || '' },
            { ...textConfig, y: 50 + marginTopHeight, text: params.pc || '' },
            { ...textConfig, y: 50 + marginTopHeight, x: marginTopWidth + 90, width: 90, text: params.gysmc || '' },
            { ...textConfig, y: 65 + marginTopHeight, text: params.storageLocationProject || '' },
            { ...textConfig, y: 65 + marginTopHeight, x: marginTopWidth + 90, width: 90, text: params.remarks || '' },
        ]);
    }
    // { type: 'roundRectangle', width: printWidth, height: labelHeight, lineWidth: 0.4, cornerWidth: 2 },
    // {
    //   type: "barcode",
    //   text: "12345678",
    //   x: 5,
    //   y: 5,
    //   width: 30,
    //   height: 20,
    //   textHeight: 4,
    //   textAlignment: 3,
    // },

    // { type: 'qrcode', text: text1, x: 10, y: 5, width: 20, eccLevel: 1 },
    // { type: 'pdf417', text: text2, x: 5, y: 5, width: 30, height: 20 },
    // // 绘制图片url
    // { type: 'image', imageFile: url, x: 10, y: 5, width: 20, height: 20 },
    // // 绘制BASE64字符串
    // { type: 'image', imageFile: imgSrc, x: 10, y: 5, width: 20, height: 20 },

    // { type: 'dashLine', x1: 0, y1: 10, x2: printWidth, y2: 10, lineWidth: 0.4, dashLen: '1,0.5' },
};